import { combineReducers } from "redux"
import languageReducer from "./language.reducer"
import typeOptionReducer from "./typeOption.reducer";
import { persistReducer } from 'redux-persist';
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";
import loadingReducer from "./loading.reducer";
import userTypeReducer from "./userType.reducer";
import pdfReducer from './pdf.reducer'
import stepReducer from "./step.reducer";

const optionPersistConfig = {
    keyPrefix: 'irpas_',
    key: 'option',
    storage,
    stateReconciler: autoMergeLevel2,
}


const rootReducer = combineReducers({
   language: languageReducer,
   option: persistReducer(optionPersistConfig, typeOptionReducer),
   loading: loadingReducer,
   userType: userTypeReducer,
   pdfReducer: persistReducer(optionPersistConfig, pdfReducer),
   stepReducer: stepReducer
})




export default rootReducer;